export default __webpack_public_path__ + "static/media/arrow_blue.db631f86.svg";